<template>
  <b-row>
    <b-col cols="12">
      <statistic-data />
    </b-col>
    <b-col cols="12">
      <anggota />
    </b-col>
    <b-col cols="12">
      <calon-anggota />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import Anggota from './Anggota.vue'
import CalonAnggota from './CalonAnggota.vue'
import StatisticData from '../dummy/StatisticAnggota.vue'

export default {
  components: {
    BRow,
    BCol,

    Anggota,
    CalonAnggota,
    StatisticData

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
